import * as React from 'react';
const SummaryContext = /*#__PURE__*/React.createContext({});
export default SummaryContext;